import React from "react";
import { Blocks } from "@/types/cms";
import { renderRichTextWithMutedStrikethrough } from "@/lib/richText";
import styles from "./SectionHeader.module.css";

interface SectionHeaderProps {
  content?: Blocks;
  align?: 'left' | 'center' | 'right';
  textAlign?: 'left' | 'center' | 'right';
  headerWidth?: 'sm' | 'md' | 'lg';
}

const SectionHeader = ({ content, align = 'center', textAlign, headerWidth }: SectionHeaderProps) => {
  if (!content) return null;

  // For center alignment, keep text left but center the wrapper unless textAlign overrides
  const containerAlign = textAlign
    ? (textAlign === 'left' ? styles.alignLeft : textAlign === 'right' ? styles.alignRight : styles.alignCenter)
    : (align === 'right' ? styles.alignRight : styles.alignLeft);
  const wrapperJustify = align === 'left' ? styles.justifyStart : align === 'right' ? styles.justifyEnd : styles.justifyCenter;

  const widthClass = headerWidth === 'sm' ? styles.wSm : headerWidth === 'lg' ? styles.wLg : headerWidth === 'md' ? styles.wMd : '';

  return (
    <div className={`${styles.container} ${containerAlign} ${widthClass}`}>
      <div className={`${styles.row} ${wrapperJustify}`}>
        <div className={styles.textWrap}>
          <div className={`${styles.full} ${styles.content}`}> 
            {renderRichTextWithMutedStrikethrough(content, {
              defaultAlign: textAlign,
              headingVariant: "title",
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;


